import React from "react";
import styles from "./UpgradePlanChipStyle.module.css";
import { openPricingPage } from "utils/Utils";

export const UpgradePlanChip = () => {
  return (
    <div className={styles.container} onClick={openPricingPage}>
      <div className={styles.text}>Upgrade Plan</div>
    </div>
  );
};
